import styled, { css } from 'styled-components'
import { Tab, Tabs, TabPanel, TabList } from 'react-tabs'

export const ForgotDetailsWrapper = styled.div``

export const TabsStyled = styled(Tabs)``

export const ForgotDetailsContent = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.light};
  `}
`
export const ForgotDetailsContentTabsContainer = styled.div`
  padding: 0 1rem;
  max-width: 55rem;
  margin: auto;
`

export const ForgotDetailsContentDescription = styled.p`
  ${({ theme }) => css`
    text-align: center;
    line-height: 1.5rem;
    color: #333;
  `};
`

export const ForgotDetailsButtonsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column-reverse;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
    margin: 0 auto;
    width: fit-content;

    & > div {
      margin: 1rem;
    }

    @media (min-width: ${theme.ToRem(480)}) {
      flex-direction: row;
    }
  `}
`

export const TabListStyled = styled(TabList)`
  ${({ theme }) => css`
    width: auto;
    display: flex;
    border-bottom: 1px solid ${theme.colors.grey};
    padding: 0;

    li {
      margin-right: 0.5rem;
      &:last-child {
        margin-right: 0;
      }
    }
  `}
`

export const TabStyled = styled(Tab)`
  ${({ theme, isAlternativeActive }) => css`
    ${theme.fonts.bold};
    list-style: none;
    flex: 1 1;
    max-width: 50%;
    font-size: min(calc(1vh + 2vw), 16px);
    padding: 2vh 0.75rem;
    text-align: center;
    cursor: pointer;
    text-transform: uppercase;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
    color: ${isAlternativeActive
      ? theme.colors.primary.default
      : theme.colors.dark};
    &.react-tabs__tab--selected {
      border-bottom: 0.25rem solid
        ${isAlternativeActive
          ? theme.colors.dark
          : theme.colors.primary.default};
      color: ${isAlternativeActive
        ? theme.colors.dark
        : theme.colors.primary.default};
      background-color: ${theme.colors.light};
      font-size: ${theme.ToRem(18)};
    }

    &:hover {
      border-bottom: 0.25rem solid
        ${isAlternativeActive
          ? theme.colors.dark
          : theme.colors.primary.default};
    }

    &:focus {
      border-bottom: 0.25rem solid
        ${isAlternativeActive
          ? theme.colors.dark
          : theme.colors.primary.default};
      color: ${isAlternativeActive
        ? theme.colors.dark
        : theme.colors.primary.default};
      background-color: ${theme.colors.light};
      font-size: ${theme.ToRem(18)};
    }
  `}
`

export const TabPanelStyled = styled(TabPanel)`
  ${({ selected }) =>
    selected &&
    css`
      padding: 0 0.75rem 1rem;
    `}
`

export const ForgotDetailsInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  input {
    width: 100%;
  }
`

export const ForgotDetailsInputDescription = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.ToRem(10)};
    line-height: 15px;
    font-weight: 500;

    button {
      font-size: ${theme.ToRem(10)};
      font-weight: 500;
      text-decoration: none;
    }
  `}
`

export const ForgotDetailsContentErrorContainer = styled.div`
  ${({ theme }) => css`
    margin: 1rem 0;
    span {
      ${theme.fonts.regular};
      color: ${theme.colors.error};
      line-height: 1.5;
      text-align: center;
      display: inline-block;
    }
  `}
`

export const RecaptchaInfoContainer = styled.div`
  ${({ theme }) => css`
    text-align: center;
    padding-bottom: 1rem;
    text-align: center;
    font-family: 'Maven Pro', sans-serif;
    font-size: 0.75rem;

    @media (min-width: ${theme.ToRem(480)}) {
    }
  `}
`
export const ButtonsFocusContainer = styled.div`
  ${({ theme }) => css`
    &:focus-within {
      border: 2px solid ${theme.colors.primary.hover};
    }
  `}
`
